import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faAlignLeft,
  faArrowRotateLeft,
  faArrowUpFromBracket,
  faArrowUpWideShort,
  faArrowsLeftRight,
  faArrowsRotate,
  faBars,
  faBell,
  faBolt,
  faBook,
  faBookOpen,
  faBrain,
  faBullhorn,
  faCalendarCheck,
  faCalendar,
  faCalendarDay,
  faCalendarDays,
  faCalendarPlus,
  faChartColumn,
  faChalkboardUser,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faCircleQuestion,
  faCircleXmark,
  faClockRotateLeft,
  faCoins,
  faCompass,
  faCloudArrowUp,
  faCookieBite,
  faDeleteLeft,
  faDice,
  faDownload,
  faEllipsisVertical,
  faEnvelope,
  faEnvelopeOpenText,
  faEye,
  faEyeSlash,
  faFeatherPointed,
  faFileContract,
  faFileLines,
  faFire,
  faFont,
  faFolder,
  faGamepad,
  faGaugeHigh,
  faGift,
  faGraduationCap,
  faHandPointer,
  faHandshake,
  faHeadphones,
  faHeart,
  faHouse,
  faInfinity,
  faKeyboard,
  faKey,
  faKitMedical,
  faLayerGroup,
  faLightbulb,
  faLink,
  faList,
  faLock,
  faLanguage,
  faMagnifyingGlass,
  faMemory,
  faMedal,
  faMobileScreen,
  faMobileScreenButton,
  faNewspaper,
  faPlane,
  faPlay,
  faPlus,
  faPuzzlePiece,
  faQuoteLeft,
  faRepeat,
  faRightFromBracket,
  faRightLeft,
  faRightToBracket,
  faRobot,
  faRocket,
  faRoute,
  faRotateRight,
  faPaperPlane,
  faPen,
  faShieldHalved,
  faShareNodes,
  faShuffle,
  faSitemap,
  faSpinner,
  faStar,
  faSpellCheck,
  faSquarePlus,
  faTable,
  faTag,
  faTriangleExclamation,
  faUpRightFromSquare,
  faUser,
  faUserCheck,
  faUserClock,
  faUserPen,
  faUserPlus,
  faUserSecret,
  faTrophy,
  faClock,
  faUpRightAndDownLeftFromCenter,
  faUsers,
  faWandMagicSparkles,
  faWindowMaximize,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';

const NON_ICON_TOKENS = new Set([
  'fa',
  'fas',
  'far',
  'fab',
  'fa-solid',
  'fa-regular',
  'fa-brands',
  'fa-spin',
  'fa-pulse',
  'fa-spin-pulse',
  'fa-fw',
]);

const ICON_MAP = {
  'fa-align-left': faAlignLeft,
  'fa-arrow-down': faArrowDown,
  'fa-arrow-left': faArrowLeft,
  'fa-arrow-right': faArrowRight,
  'fa-arrow-up': faArrowUp,
  'fa-arrow-up-from-bracket': faArrowUpFromBracket,
  'fa-arrow-up-wide-short': faArrowUpWideShort,
  'fa-arrows-left-right': faArrowsLeftRight,
  'fa-bars': faBars,
  'fa-backspace': faDeleteLeft,
  'fa-bell': faBell,
  'fa-bolt': faBolt,
  'fa-book': faBook,
  'fa-book-open': faBookOpen,
  'fa-brain': faBrain,
  'fa-bullhorn': faBullhorn,
  'fa-calendar': faCalendar,
  'fa-calendar-alt': faCalendarDays,
  'fa-calendar-check': faCalendarCheck,
  'fa-calendar-day': faCalendarDay,
  'fa-calendar-days': faCalendarDays,
  'fa-calendar-plus': faCalendarPlus,
  'fa-chart-bar': faChartColumn,
  'fa-chart-line': faChartColumn,
  'fa-chalkboard-teacher': faChalkboardUser,
  'fa-chalkboard-user': faChalkboardUser,
  'fa-chevron-down': faChevronDown,
  'fa-chevron-left': faChevronLeft,
  'fa-chevron-right': faChevronRight,
  'fa-chevron-up': faChevronUp,
  'fa-check': faCheck,
  'fa-check-circle': faCircleCheck,
  'fa-circle-check': faCircleCheck,
  'fa-circle-exclamation': faCircleExclamation,
  'fa-circle-info': faCircleInfo,
  'fa-circle-question': faCircleQuestion,
  'fa-circle-xmark': faCircleXmark,
  'fa-coins': faCoins,
  'fa-compass': faCompass,
  'fa-cookie-bite': faCookieBite,
  'fa-cloud-upload-alt': faCloudArrowUp,
  'fa-dice': faDice,
  'fa-download': faDownload,
  'fa-ellipsis-vertical': faEllipsisVertical,
  'fa-envelope': faEnvelope,
  'fa-envelope-open-text': faEnvelopeOpenText,
  'fa-exchange-alt': faRightLeft,
  'fa-exclamation-circle': faCircleExclamation,
  'fa-exclamation-triangle': faTriangleExclamation,
  'fa-expand': faUpRightAndDownLeftFromCenter,
  'fa-expand-arrows-alt': faUpRightAndDownLeftFromCenter,
  'fa-external-link': faUpRightFromSquare,
  'fa-external-link-alt': faUpRightFromSquare,
  'fa-eye': faEye,
  'fa-eye-slash': faEyeSlash,
  'fa-feather-alt': faFeatherPointed,
  'fa-file-contract': faFileContract,
  'fa-file-lines': faFileLines,
  'fa-fire': faFire,
  'fa-font': faFont,
  'fa-folder': faFolder,
  'fa-gamepad': faGamepad,
  'fa-gauge-high': faGaugeHigh,
  'fa-gift': faGift,
  'fa-graduation-cap': faGraduationCap,
  'fa-hand-pointer': faHandPointer,
  'fa-handshake': faHandshake,
  'fa-headphones': faHeadphones,
  'fa-heart': faHeart,
  'fa-history': faClockRotateLeft,
  'fa-home': faHouse,
  'fa-house': faHouse,
  'fa-infinity': faInfinity,
  'fa-info-circle': faCircleInfo,
  'fa-keyboard': faKeyboard,
  'fa-key': faKey,
  'fa-medkit': faKitMedical,
  'fa-layer-group': faLayerGroup,
  'fa-language': faLanguage,
  'fa-learning-books': faBookOpen,
  'fa-lightbulb': faLightbulb,
  'fa-link': faLink,
  'fa-list': faList,
  'fa-lock': faLock,
  'fa-magic': faWandMagicSparkles,
  'fa-memory': faMemory,
  'fa-medal': faMedal,
  'fa-magnifying-glass': faMagnifyingGlass,
  'fa-mobile-screen': faMobileScreen,
  'fa-mobile-screen-button': faMobileScreenButton,
  'fa-newspaper': faNewspaper,
  'fa-paper-plane': faPaperPlane,
  'fa-pen': faPen,
  'fa-plane': faPlane,
  'fa-play': faPlay,
  'fa-plus': faPlus,
  'fa-plus-square': faSquarePlus,
  'fa-puzzle-piece': faPuzzlePiece,
  'fa-question-circle': faCircleQuestion,
  'fa-quote-left': faQuoteLeft,
  'fa-random': faShuffle,
  'fa-redo': faRotateRight,
  'fa-refresh': faArrowsRotate,
  'fa-repeat': faRepeat,
  'fa-robot': faRobot,
  'fa-rotate-right': faRotateRight,
  'fa-rotate': faArrowsRotate,
  'fa-rocket': faRocket,
  'fa-route': faRoute,
  'fa-right-from-bracket': faRightFromBracket,
  'fa-right-to-bracket': faRightToBracket,
  'fa-share-alt': faShareNodes,
  'fa-share-nodes': faShareNodes,
  'fa-shield-alt': faShieldHalved,
  'fa-shield-halved': faShieldHalved,
  'fa-search': faMagnifyingGlass,
  'fa-sign-out-alt': faRightFromBracket,
  'fa-sliders-h': faSitemap,
  'fa-sitemap': faSitemap,
  'fa-sparkles': faWandMagicSparkles,
  'fa-spinner': faSpinner,
  'fa-star': faStar,
  'fa-spell-check': faSpellCheck,
  'fa-stream': faShareNodes,
  'fa-sync': faArrowsRotate,
  'fa-sync-alt': faArrowsRotate,
  'fa-table': faTable,
  'fa-tag': faTag,
  'fa-trash': faDeleteLeft,
  'fa-trophy': faTrophy,
  'fa-user': faUser,
  'fa-user-check': faUserCheck,
  'fa-user-clock': faUserClock,
  'fa-user-edit': faUserPen,
  'fa-user-pen': faUserPen,
  'fa-user-plus': faUserPlus,
  'fa-user-secret': faUserSecret,
  'fa-users': faUsers,
  'fa-list-alt': faList,
  'fa-times': faXmark,
  'fa-times-circle': faCircleXmark,
  'fa-xmark': faXmark,
  'fa-undo': faArrowRotateLeft,
  'fa-wand-magic-sparkles': faWandMagicSparkles,
  'fa-window-maximize': faWindowMaximize,
  'fa-clock': faClock,
};

const getIconToken = (className = '') =>
  className
    .split(/\s+/)
    .find((token) => token.startsWith('fa-') && !NON_ICON_TOKENS.has(token));

const FaIcon = ({ className = '', ...rest }) => {
  const classTokens = className.split(/\s+/);
  const iconToken = getIconToken(className);
  const icon = iconToken ? ICON_MAP[iconToken] : null;

  if (!icon) {
    return (
      <i className={className} {...rest}>
        <FontAwesomeIcon icon={faCircleQuestion} spin={classTokens.includes('fa-spin')} />
      </i>
    );
  }

  return (
    <i className={className} {...rest}>
      <FontAwesomeIcon icon={icon} spin={classTokens.includes('fa-spin')} />
    </i>
  );
};

export default FaIcon;
